import PropTypes from 'prop-types';
import {StatsigProvider as VendorStatsigProvider} from '@statsig/react-bindings';
import {StatsigClient} from './client';

export const StatsigProvider = ({children}) => {
    const client = StatsigClient.get();

    if (!client) {
        return children;
    }

    return (
        <VendorStatsigProvider client={client}>
            {children}
        </VendorStatsigProvider>
    );
};

StatsigProvider.propTypes = {
    children: PropTypes.node,
};
